<template>
  <div class="van-page">
    <the-header title="项目详情" isShowArrow />
    <div class="van-container">
      <div class="detailContainer">
        <div class="contentContainer">
          <h3>
            {{ project.PROJECT_NAME }}
          </h3>
          <div class="cell">
            <p class="cell-title">项目编号</p>
            <p class="content">：{{ project.PROJECT_CODE }}</p>
          </div>
          <div class="cell">
            <p class="cell-title">业主单位</p>
            <p class="content">：{{ project.OWNER_COMPANY }}</p>
          </div>
          <div class="cell">
            <p class="cell-title">总投资</p>
            <p class="content">：{{ project.TOTAL_INVEST }}万</p>
          </div>
          <div class="cell">
            <p class="cell-title">项目管家</p>
            <p class="content">：{{ project.MAIN_ASSIGN_USER||'暂未分配' }}</p>
          </div>
          <div class="cell">
            <p class="cell-title">管家电话</p>
            <p class="content">：{{ project.MAIN_ASSIGN_PHONE||'暂未分配' }}</p>
          </div>
        </div>
      </div>
      <van-panel>
        <template #header>
          <van-tabs v-model="active">
            <van-tab title="审批进度">
              <div class="van-panel-content">
                <schedule></schedule>
              </div>
            </van-tab>
            <van-tab title="审批计划">
              <div class="van-panel-content">
                <approve></approve>
              </div>
            </van-tab>
            <van-tab title="事项定制">
              <div class="van-panel-content">
                <matter></matter>
              </div>
            </van-tab>
          </van-tabs>
        </template>
      </van-panel>
    </div>
  </div>
</template>
<script>
import { getProjectInfo } from '@/api/interface/project'
export default {
  name: 'projectDetail',
  components: {
    schedule: () => import('./components/schedule'),
    approve: () => import('./components/approve'),
    matter: () => import('./components/matter'),
        'the-header': () => import('@/components/TheHeader')
  },
  data() {
    return {
      title: '',
      active: 0,
      project:{},
      code:null
    }
  },
  methods: {
    getData(){
      const instance = getProjectInfo({projectCode:this.code.get('projectCode')})
      instance
      .then((result) => {
        this.project=result.data.info
      }).catch((err) => {
        console.log(err);
      });
    }
  },
  created(){
    try {
      const href = location.href
      this.code = new Map()
      if (href.includes('?')) href.split('?')[1].split('&').forEach(item => {
        const temp = item.split('=')
        this.code.set(temp[0], temp[1].split('#')[0])
      });
    } catch (err) {
      console.log(err);
    }
  },
  mounted() {
    this.getData()
  }
}
</script>
<style lang="less" scoped>
.van-page {
  min-height: 100vh;
  min-width: 100vw;
  background: linear-gradient(135deg, rgba(210, 236, 255, 1) 0%, white 6%, white 100%);
  // padding-bottom: 70px;
  position: relative;
}

.van-container {
  padding: 16px 16px;
}

::v-deep {

  .van-tab__pane,
  .van-tab__pane-wrapper {
    height: 65vh;
    overflow-y: auto;
  }


  .van-tabs__line {
    width: 13px;
    background: linear-gradient(270deg,
        #427af4 0.92%,
        rgba(66, 122, 244, 0) 100%);
  }

  .van-tabs__wrap {
    position: sticky;
    top: 45px;
    margin-top: 15px;
    z-index: 9999;
    border-bottom: 1px solid #eee;
  }

}

.detailContainer {
  width: 100%;
  height: fit-content;
  display: flex;
  font-size: 16px;

  .contentContainer {
    .title {
      font-size: large;
      font-weight: 500;
      color: black;
      margin-bottom: 20px;
    }
    .cell{
      display: flex;
      .cell-title{
        width: 2rem;
      }
    }
    
      .content {
        height: 20px;
        line-height: 20px;
        width: 200px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        color: black;
      }

  }
}</style>

<style lang="less" scoped>
.van-page {
  min-height: 100vh;
  min-width: 100vw;
  background: linear-gradient(135deg, rgba(210, 236, 255, 1) 0%, white 6%, white 100%);
  // padding-bottom: 70px;
  position: relative;
}

.van-container {
  padding: 16px 16px;
}

::v-deep {

  .van-tab__pane,
  .van-tab__pane-wrapper {
    height: 65vh;
    overflow-y: auto;
  }



  .van-tabs__line {
    width: 13px;
    background: linear-gradient(270deg,
        #427af4 0.92%,
        rgba(66, 122, 244, 0) 100%);
  }

  .van-tabs__wrap {
    position: sticky;
    top: 45px;
    margin-top: 15px;
    z-index: 9999;
    border-bottom: 1px solid #eee;
  }

}

.tag {
  align-self: flex-start;
  margin: 2px 5px;
}

.detailContainer {
  width: 100%;
  height: fit-content;
  display: flex;

  .tagContainer {
    width: 2rem;
    margin-right: 10px;

    .tag {
      height: 20px;
      font-weight: 200;
      width: 1rem;
      padding: 5px;
      font-size: small;
      background: linear-gradient(135deg, #ffffffbb 0%, rgb(82, 143, 247) 20%, rgb(82, 143, 247) 100%);
    }
  }

}</style>